import { ChevronDownIcon } from '@assets/icons';
import { Group } from '@components/layout';
import { Typography } from '@components/typography';
import { Box, Collapse, Stack, useTheme } from '@mui/material';
import { useState } from 'react';
import { AutoDeleteField } from './AutoDeleteField';
import { AutoStopField } from './AutoStopField';
import { AutoUpdateField } from './AutoUpdateField';

export const AdvancedSettingsSection = () => {
  const { palette } = useTheme();
  const [advancedOpen, setAdvancedOpen] = useState(false);
  return (
    <Box sx={{ mb: 5 }}>
      <Group
        onClick={() => setAdvancedOpen((prev) => !prev)}
        sx={{
          alignItems: 'center',
          gap: 1,
          cursor: 'pointer',
          userSelect: 'none',
          py: 1,
        }}
      >
        <Typography variant="caption1" color={palette.text.accent}>
          Advanced Settings
        </Typography>
        <ChevronDownIcon
          size={16}
          style={{
            transform: advancedOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease-in-out',
            color: palette.text.accent,
          }}
        />
      </Group>
      <Collapse in={advancedOpen}>
        <Stack gap={2} sx={{ pt: 1 }}>
          <AutoStopField />
          <AutoDeleteField />
          <AutoUpdateField />
        </Stack>
      </Collapse>
    </Box>
  );
};
